import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterprisePageGuard from 'bundles/unified-description-page-common/pages/enterprise/EnterprisePageGuard';
import EnterpriseCoursePageRootContent from 'bundles/unified-description-page-common/pages/enterprise/course/EnterpriseCoursePageRootContent';
import EnterpriseAdminEnrollmentDataProvider from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseAdminEnrollmentDataProvider';
import { EnterpriseLearnerFlowOptimizationDataProvider } from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseLearnerFlowOptimizationDataProvider';
import EnterpriseCoursePageDataProvider from 'bundles/unified-description-page-common/providers/enterprise/pages/EnterpriseCoursePageDataProvider';

const EnterpriseCoursePageRoot = () => {
  return (
    <div data-e2e="unified-course-page">
      <EnterpriseCoursePageDataProvider>
        <EnterprisePageTemplateWrapper>
          <EnterprisePageGuard>
            <EnterpriseAdminEnrollmentDataProvider>
              <EnterpriseLearnerFlowOptimizationDataProvider>
                <EnterpriseCoursePageRootContent />
              </EnterpriseLearnerFlowOptimizationDataProvider>
            </EnterpriseAdminEnrollmentDataProvider>
          </EnterprisePageGuard>
        </EnterprisePageTemplateWrapper>
      </EnterpriseCoursePageDataProvider>
    </div>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'unified_description_page',
      page: 'enterprise_course_page',
    },
  }))
)(EnterpriseCoursePageRoot);
